import SyosUiContainer from './SyosUiContainer';
import syosMediaQuery from './utils/syosMediaQuery';
import SyosEvents from './utils/SyosEvents';
import SyosPageComponent from './SyosPageComponent';

const HTML = `
  <button class="tn-syos-btn-view-screens">
    <i class="fa fa-chevron-left tn-syos-btn-view-screens__icon" aria-hidden="true"></i>
    <span class="tn-syos-btn-view-screens__label"></span>
  </button>
`;

class SyosBtnViewScreens extends SyosUiContainer {
  constructor(syosController) {
    super(syosController, '.tn-syos-btn-view-screens__container');
    this.bindMethods();

    this.$el.html(HTML);

    this.$btnViewScreens = this.find('.tn-syos-btn-view-screens');
    this.$btnViewScreensLabel = this.find('.tn-syos-btn-view-screens__label');

    this.$btnViewScreens.hide();

    this.$btnViewScreens.on('click', () => {
      this.syosController.unsetCurrentScreen();
    });

    this.syosController.once(SyosEvents.SCREENS_DATA_LOADED, this.onScreenDataLoaded);
  }

  bindMethods() {
    this.onScreenDataLoaded = this.onScreenDataLoaded.bind(this);
    this.onMobileEnter = this.onMobileEnter.bind(this);
    this.onMobileLeave = this.onMobileLeave.bind(this);
  }

  onScreenDataLoaded({ screens }) {
    this.screens = screens;

    syosMediaQuery.on(SyosEvents.MOBILE_ENTER, this.onMobileEnter);
    syosMediaQuery.on(SyosEvents.MOBILE_LEAVE, this.onMobileLeave);

    this.syosController.on(SyosEvents.SCREEN_UPDATED, () => this.updateBtnDisplay());

    if (syosMediaQuery.testIsMobile()) {
      this.onMobileEnter();
    } else {
      this.onMobileLeave();
    }

    this.updateBtnDisplay();
  }

  getUiState() {
    const isInSeatView = this.syosController.getCurrentScreen() !== null;
    const isMobile = syosMediaQuery.testIsMobile();
    const isSingleScreen = this.screens.length === 1;
    const isUsingCustomBirdsEye = this.syosController.getIsUsingCustomBirdsEye();
    const isConfiguredToSkipOverview =
      isSingleScreen && this.screens[0].SkipScreenSelection === true;

    return {
      isSingleScreen,
      isInSeatView,
      isMobile,
      isConfiguredToSkipOverview,
      isUsingCustomBirdsEye,

      // Convenience negations
      isInOverview: !isInSeatView,
      isMultiScreen: !isSingleScreen,
      isDesktop: !isMobile,
      isConfiguredToPresentOverview: !isConfiguredToSkipOverview,
      isNotUsingCustomBirdsEye: !isUsingCustomBirdsEye,
    };
  }

  onMobileEnter() {
    const { isInSeatView } = this.getUiState();

    if (isInSeatView) {
      this.syosController.unsetCurrentScreen();
    } else {
      this.updateBtnDisplay();
    }
  }

  onMobileLeave() {
    const { isInOverview, isConfiguredToSkipOverview } = this.getUiState();

    if (isInOverview && isConfiguredToSkipOverview) {
      window.setTimeout(() => {
        this.syosController.setCurrentScreen(this.screens[0]);
      });
    } else {
      this.updateBtnDisplay();
    }
  }

  updateBtnDisplay() {
    const label = this.getButtonLabel();

    if (label === null) {
      this.$btnViewScreens.hide();
    } else {
      this.$btnViewScreensLabel.html(label);
      this.$btnViewScreens.show();
    }
  }

  /**
   * Returns the appropriate label based on current state.
   * Returns `null` if button should not be visible.
   * @returns {null|string}
   */
  getButtonLabel() {
    const {
      isMobile,
      isInOverview,
      isDesktop,
      isMultiScreen,
      isSingleScreen,
      isConfiguredToPresentOverview,
      isNotUsingCustomBirdsEye,
    } = this.getUiState();

    if (isInOverview) {
      // Button should always be hidden @ the overview
      return null;
    }

    if (isSingleScreen && isConfiguredToPresentOverview && isNotUsingCustomBirdsEye) {
      return SyosPageComponent.backToSeatMapButtonLabel;
    }

    if (isMultiScreen) {
      return SyosPageComponent.viewFullMapLink;
    }

    if (isMobile) {
      return SyosPageComponent.viewEventDetailsButtonLabel;
    }

    if (isDesktop && isConfiguredToPresentOverview) {
      return SyosPageComponent.backToSeatMapButtonLabel;
    }

    // In all other cases, button should be hidden
    return null;
  }
}

export default SyosBtnViewScreens;



// WEBPACK FOOTER //
// ./src/syos/SyosBtnViewScreens.js